import { z } from 'zod'

export const pinV1Schema = z.object({
  schema_version: z.literal(1),
  walk_call: z.object({
    function: z.string(),
    fact_table: z.string(),
    kpi: z.string(),
    params: z.object({
      from: z.string(),
      to: z.string(),
      filter_dims: z.record(z.array(z.string())),
      group_by: z.array(z.string()),
      bucket_size: z.enum(['day', 'week', 'month', 'quarter', 'year']).optional(),
      aggregation: z.enum(['sum', 'avg', 'max', 'min']).optional(),
      value_types: z.array(z.string()).optional(),
    }),
  }),
  render_hint: z.object({
    chart_type: z.string(),
    title: z.string().optional(),
    viz_params: z.record(z.unknown()).optional(),
    // FY v2: the DISPLAY unit the pin was created at. Optional — legacy pins lack it and
    // replay at their frozen wire bucket (replayUnitOf). Six values incl. 'fy'; distinct
    // from walk_call.params.bucket_size, which stays the five-value WIRE enum ('fy' must
    // never reach p_bucketsize — v1 invariant).
    render_unit: z.enum(['day', 'week', 'month', 'quarter', 'year', 'fy']).optional(),
  }),
})
export type PinV1 = z.infer<typeof pinV1Schema>

export const anyPinSchema = z.object({ schema_version: z.number().int() }).passthrough()
export type AnyPin = z.infer<typeof anyPinSchema>
